import { useNavigate } from "react-router-dom";
import { ListSearch } from "./ListSearch";
import { ListFilter } from "./ListFilter";

const ListToolbar = () => {
  const navigate = useNavigate();
  
  return (
    <div
      className="d-flex justify-content-end align-items-center gap-3"
      data-kt-transfer-table-toolbar="base"
    >
      <ListSearch />
      <button
        className="btn btn-primary fw-bold"
        onClick={() => navigate("create")}
      >
        <span className="indicator-label">Create New User</span>
      </button>
      {/* NEXT DEVELOPMENT */}
      {/* <ListFilter /> */}
    </div>
  );
};

export { ListToolbar };
